/**
 * WCO-2914 — attach the wf-auth token (`x-wayfong-token`) to every same-origin /api request.
 *
 * The api-gateway re-checks HTE access on all of /api. The shared `api` and operatorService axios
 * instances attach the header themselves, but a dozen screens call the gateway with plain fetch()
 * (printers, scales, label printing, settings) or with the default axios export (offline sync queue,
 * label print). Installing once at startup covers those and any call site added later, instead of
 * relying on each one remembering. Cross-origin URLs are left untouched (see wfAuthHeaderFor).
 */
import axios from 'axios';
import { wfAuthHeaderFor } from './oauthService';

const HEADER = 'x-wayfong-token';
let installed = false;

export function installWfAuthHeader(): void {
  if (installed) return;
  installed = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    const value = wfAuthHeaderFor(url)[HEADER];
    if (!value) return nativeFetch(input, init);
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has(HEADER)) headers.set(HEADER, value);
    return nativeFetch(input, { ...init, headers });
  };

  axios.interceptors.request.use((config) => {
    const value = wfAuthHeaderFor(config.url || '')[HEADER];
    if (value && config.headers && !config.headers[HEADER]) config.headers[HEADER] = value;
    return config;
  });
}
